var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h3',[_vm._v("Please wait....Checking your profile")])
}
var staticRenderFns = []

export { render, staticRenderFns }